<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Product List</h5>
      <br />
      <b-row>
        <b-col
          v-for="data in productGroups"
          :key="data.id"
          sm="6"
          lg="4"
          md="4"
          class="my-2"
        >
          <b-card
            @click="getDetailProductGroup(data.provider_id, data.brand_name, data.type, data.bill_type)"
            style="cursor: pointer"
            v-if="productGroups.length > 0"
          >
            <h5 class="text-primary font-weight-bold">
              {{ data.brand_name }}
            </h5>
            <p class="text-capitalize">{{ data.type | remove_underscore }} - {{ data.bill_type | remove_underscore }}</p>
          </b-card>
          <h5 v-else class="text-gray-500 text-center">Data Empty</h5>
        </b-col>
      </b-row>
      <br />
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <router-link :to="{name: 'createPPOBProduct'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <b-table
        v-else
        responsive
        show-empty
        hover
        ref="ppobProduct"
        :items="getInfo"
        :fields="types"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(created_at)="{ item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>
        </template>
        <template v-slot:cell(updated_at)="{ item }">
          <span v-if="item.updated_at_date_only">
            <p class="mb-0">{{item.updated_at_date_only}} by {{item.updated_by_username}}</p>
          </span>
          <span v-else>
            -
          </span>
        </template>
        <template v-slot:cell(publish_rate)="{ item }">
          <span>
            {{item.publish_rate | rupiah}}
          </span>
        </template>
        <template v-slot:cell(is_adjustment)="{ item }">
          <span v-if="item.is_adjustment">
            <b>Yes</b>
          </span>
          <span v-else>
            No
          </span>
        </template>
        <template v-slot:cell(type)="{ item }">
          <span class="text-capitalize">
            {{item.type | remove_underscore}}
          </span>
        </template>
        <template v-slot:cell(action)="{item}">
          <b-row>
            <b-link v-b-tooltip.hover title="View" class="text-dark" @click="modalShow = !modalShow">
              <img src="@/assets/ic-view.png" class="mr-2" alt @click="getDetail(item.id)" />
            </b-link>
            <router-link
              v-b-tooltip.hover
              title="Edit"
              :to="{name: 'editPPOBProduct', params: {id: item.id}}"
              class="text-dark"
            >
              <img src="@/assets/ic-edit.svg" class="mr-2" alt />
            </router-link>
            <b-form-checkbox
              switch
              v-model="item.status"
              name="check-button"
              @change="activation(item)"
            ></b-form-checkbox>
            <span v-if="item.status" class="text-primary">&nbsp;Active</span>
            <span v-else>&nbsp;Inactive</span>
          </b-row>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">
          <div v-if="totalRows == 0 || totalRows == null">
            Showing 0 Records
          </div>
          <div v-else>
            Showing {{ fromPage[currentPage - 1] }} to
            {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
          </div>
        </b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-model="modalShow"
      size="l"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h2 class="font-weight-bold">Details</h2>
          </b-col>
          <b-col md="3" class="text-right text-primary font-weight-bold">
            <router-link
              class="text-decoration-none text-primary"
              :to="{
                name: 'editPPOBProduct',
                params: { id: detail.id },
              }"
            >
              <i class="fas fa-edit"></i>&nbsp; Edit
            </router-link>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Date Created"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.created_at_date_only}}</p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Last Updated"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p v-if="detail.updated_at_date_only" style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.updated_at_date_only}} by {{detail.updated_by_username}}</p>
              <label v-else style="font-size: 12px;font-weight: normal !important">-</label>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Product Type"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.type}}</p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Brand Name"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.brand_name}}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Display Name (English)"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.display_name ? detail.display_name.en : '-'}}</p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Display Name (Bahasa)"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.display_name ? detail.display_name.id : '-'}}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Description (English)"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.description ? detail.description.en : '-'}}</p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Description (Bahasa)"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.description ? detail.description.id : '-'}}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Base Rate"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.base_rate | rupiah}}</p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Publish Rate"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.publish_rate | rupiah}}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Adjustment"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.is_adjustment ? "Yes" : "No"}}</p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Adjustment Type"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p  v-if="detail.is_adjustment" style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.adjustment_type}}</p>
              <label  v-else style="font-size: 12px;font-weight: normal !important">-</label>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Adjustment Amount"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p v-if="detail.is_adjustment && detail.adjustment_type === 'amount'" style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.adjustment_amount | rupiah}}</p>
              <p v-else-if="detail.is_adjustment && detail.adjustment_type === 'percentage'" style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.adjustment_amount | percentage_symbol}}</p>
              <label v-else style="font-size: 12px;font-weight: normal !important">-</label>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Adjustment As"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p  v-if="detail.is_adjustment" style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.adjustment_as}}</p>
              <label  v-else style="font-size: 12px;font-weight: normal !important">-</label>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Special Rate"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.special_rate | rupiah}}</p>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold"
              label="Crossout Publish Rate"
              label-for="input-1"
              style="font-size: 12px"
            >
              <p style="font-size: 12px;font-weight: normal !important;word-break: break-all;">{{detail.is_cross_out_publish_rate ? "Yes" : "No"}}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-button
              variant="light"
              @click="modalShow = !modalShow"
              class="text-primary"
              block
              size="lg"
              >Close</b-button
            >
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal
      v-model="detailProductGroupShow"
      id="modal-prevent-closing"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="md"
    >
      <b-spinner
        label="Spinning"
        v-show="loadingPopupDetailProductGroup"
      ></b-spinner>
      <div v-show="!loadingPopupDetailProductGroup">
        <b-container>
          <b-row>
            <b-col>
              <h5 class="text-primary font-weight-bold">
                {{ brandNamePopUp }}
              </h5>
            </b-col>
          </b-row>
          <b-row  class="mb-4">
            <b-col md="4" class="text-capitalize"><b>{{productTypePopUp | remove_underscore}}</b></b-col>
          </b-row>
          <b-row>
            <b-col>
              <draggable @change="updateProductOrder()" handle=".handle" v-model="productGroupByProviderAndTypeAndBillType" v-bind="dragOptions" group="people" :move="onMove">
                <transition-group type="transition" :name="'flip-list'">
                  <li class="list-group-item" v-for="element in productGroupByProviderAndTypeAndBillType" :key="element.id">
                    <b-row>
                      <b-col class="pr-0" md="1"><i class="fas fa-bars handle"></i></b-col>
                      <b-col class="text-left pl-0">{{ element.display_name.en }} </b-col>
                      <b-col class="text-right">
                        <b-row>
                          <b-col class="text-right p-0">
                            <b-form-checkbox
                              v-model="element.status"
                              name="check-button"
                              switch
                              @change="activation(element)"
                            ></b-form-checkbox>
                          </b-col>
                          <b-col md="4" class="text-left p-0">
                            {{element.status ? 'Enabled':'Disabled'}}
                          </b-col>
                          <b-col md="1" class="text-left p-0">
                            <b-link v-b-tooltip.hover title="View" class="text-dark" @click="modalShow = !modalShow">
                              <img src="@/assets/ic-view.png" class="mr-2" alt height="16px" @click="getDetail(element.id)" />
                            </b-link>
                          </b-col>
                          <b-col md="2" class="text-left p-0">
                            <router-link
                              v-b-tooltip.hover
                              title="Edit"
                              :to="{name: 'editPPOBProduct', params: {id: element.id}}"
                              class="text-dark"
                            >
                              <img src="@/assets/ic-edit.svg" class="mr-2" alt height="16px" />
                            </router-link>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </li>
                </transition-group>
              </draggable>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <br />

      <br />
      <b-container>
        <b-row>
          <b-col>
            <b-button
              variant="light"
              @click="detailProductGroupShow = !detailProductGroupShow"
              class="text-primary"
              block
              :disabled="loadingProductOrder || loadingPopupDetailProductGroup"
              size="lg"
              >
              <b-spinner
                label="Spinning"
                v-show="loadingProductOrder"
              ></b-spinner>Closed</b-button
            >
          </b-col>
          <!-- <b-col>
            <b-button
              variant="primary"
              :disabled="loadingProductOrder || loadingPopupDetailProductGroup"
              @click="updateProductOrder()"
              block
              size="lg"
            >
              <b-spinner
                label="Spinning"
                v-show="loadingProductOrder"
              ></b-spinner
              >Save
            </b-button>
          </b-col> -->
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  data() {
    return {
      loading: true,
      errored: false,
      items: [],
      detail: {},
      modalShow: false,
      types: [
        {
          key: "created_at",
          label: "Date Created",
          sortable: false,
          class: "text-left"
        },
        {
          key: "updated_at",
          label: "Last Updated",
          sortable: false,
          class: "text-left w-14"
        },
        {
          key: "type",
          label: "Product Type",
          sortable: false,
          class: "text-left"
        },
        {
          key: "brand_name",
          label: "Brand Name",
          sortable: false,
          class: "text-left"
        },
        {
          key: "display_name.en",
          label: "Display Name (Eng)",
          sortable: false,
          class: "text-left w-20"
        },
        {
          key: "is_adjustment",
          label: "Adjustment",
          sortable: false,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-left w-14" }
      ],
      fromPage: [],
      toPage: [],
      productGroups: [],
      productGroupByProviderAndTypeAndBillType: [],
      originalProductGroupByProviderAndTypeAndBillType: [],
      brandNamePopUp: "",
      productTypePopUp: "",
      editable: true,
      productOrderChange: {
        id: "",
        order: 1,
        type: "",
        provider_id: "",
        bill_type: "",
      },
      detailProductGroupShow: false,
      loadingProductOrder: false,
      loadingPopupDetailProductGroup: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    },
  },
  beforeMount() {
    this.$store
      .dispatch("PPOBProductModule/getAllPPOBProductGroupByProviderAndTypeAndBillType")
      .then((response) => {
        this.productGroups = response.data.data;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.productGroups = [];
      });
  },
  methods: {
    getDetail(payload) {
      this.$store
        .dispatch("PPOBProductModule/getPPOBProduct", payload)
        .then(response => {
          this.detail = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDetailProductGroup(provider_id, brand_name, product_type, bill_type) {
      this.brandNamePopUp = brand_name;
      this.productTypePopUp = product_type;
      this.detailProductGroupShow = true;
      this.loadingPopupDetailProductGroup = true;
      const payload = {
        provider_id: provider_id,
        product_type: product_type,
        bill_type: bill_type
      }
      this.$store
        .dispatch("PPOBProductModule/getPPOBProductByProviderAndTypeAndBillType", payload)
        .then((response) => {
          this.loadingPopupDetailProductGroup = false;
          this.productGroupByProviderAndTypeAndBillType = response.data.data;
          this.originalProductGroupByProviderAndTypeAndBillType = response.data.data
        })
        .catch((error) => {
          this.loadingPopupDetailProductGroup = false;
          var message = error.response.data.data.toString();
          this.productGroupByProviderAndTypeAndBillType = [];
          this.$swal({
            type: "error",
            title: "Oops...",
            text: message,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", false);
      this.$store
        .dispatch("PPOBProductModule/getPPOBProductWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.items = response.data.data.results || [];
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading = false;
          callback([]);
        });
      return null;
    },
    activation(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You will change status Product!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          const formData = new FormData();
          formData.append("status", item.status);
          const payload = {
            id: item.id,
            data: formData,
          };
          this.$store
            .dispatch("PPOBProductModule/updateStatus", payload)
            .then((response) => {
              this.loading = false;
              this.$refs.ppobProduct.refresh();
            })
            .catch((error) => {
              this.loading = false;
              this.$refs.ppobProduct.refresh();
              this.$swal({
                title: "Cannot deactivate",
                text: error.response.data.message,
                confirmButtonColor: "#6051a2",
                confirmButtonText: "Ok",
              });
              item.status = !item.status;
            });
        } else {
          item.status = !item.status;
        }
      });
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      this.productOrderChange = {
        id: draggedElement.id,
        order: draggedContext.futureIndex + 1,
        type: draggedElement.type,
        provider_id: draggedElement.provider_id,
        bill_type: draggedElement.bill_type,
      }
      return(true)
    },
    updateProductOrder() {
      this.$swal({
        title: "Are you sure?",
        text: "You will change order of Product!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.value) {
          this.loadingProductOrder = true;
          const formData = new FormData();
          formData.append("provider_id", this.productOrderChange.provider_id);
          formData.append("type", this.productOrderChange.type);
          formData.append("order", this.productOrderChange.order);
          formData.append("bill_type", this.productOrderChange.bill_type);
          const payload = {
            id: this.productOrderChange.id,
            data: formData,
          };
          this.$store
            .dispatch("PPOBProductModule/changeOrderByTypeAndBillType", payload)
            .then((response) => {
              this.loadingProductOrder = false;
            })
            .catch((error) => {
              this.loadingProductOrder = false;
              this.productGroupByProviderAndTypeAndBillType = this.originalProductGroupByProviderAndTypeAndBillType;
              this.productOrderChange = {
                id: "",
                order: 1,
                type: "",
                provider_id: "",
                bill_type: "",
              };
              this.$swal({
                title: "Cannot change order",
                text: error.response.data.message,
                confirmButtonColor: "#6051a2",
                confirmButtonText: "Ok",
              });
            });
        } else {
          this.productGroupByProviderAndTypeAndBillType = this.originalProductGroupByProviderAndTypeAndBillType;
          this.productOrderChange = {
            id: "",
            order: 1,
            type: "",
            provider_id: "",
            bill_type: "",
          };
        }
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  }
};
</script>

<style scoped>

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  padding: 0.2rem 1rem;
  background-color: #f9f9fb;
  margin-bottom: 3px;
}
.list-group-item i {
  cursor: pointer;
}
u {
  text-decoration: underline;
}
</style>